import { render, staticRenderFns } from "./CustomCard.vue?vue&type=template&id=8cb47e7a&scoped=true"
import script from "./CustomCard.vue?vue&type=script&lang=js"
export * from "./CustomCard.vue?vue&type=script&lang=js"
import style0 from "./CustomCard.vue?vue&type=style&index=0&id=8cb47e7a&prod&scoped=true&lang=scss"
import style1 from "./CustomCard.vue?vue&type=style&index=1&id=8cb47e7a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8cb47e7a",
  null
  
)

export default component.exports